<template>
  <div class="controls">
    <div class="form-grid">
      <div class="form-group">
        <label for="project-id">Project ID</label>
        <input 
          id="project-id"
          :value="formData.project_id"
          @input="updateField('project_id', $event.target.value)"
          type="text" 
          placeholder="e.g. 201"
        />
      </div>
      
      <!-- <div class="form-group">
        <label for="mood-tone">Mood & Tone</label>
        <select 
          id="mood-tone" 
          :value="formData.mood_and_tone"
          @change="updateField('mood_and_tone', $event.target.value)"
        >
          <option value="Professional">Professional</option>
          <option value="Casual">Casual</option>
          <option value="Friendly">Friendly</option>
          <option value="Formal">Formal</option>
          <option value="Persuasive">Persuasive</option>
        </select>
      </div>
      
      <div class="form-group">
        <label for="target-audience">Target Audience</label>
        <select 
          id="target-audience" 
          :value="formData.target_audiences"
          @change="updateField('target_audiences', $event.target.value)"
        >
          <option value="Investors">Investors</option>
          <option value="First-time Buyers">First-time Buyers</option>
          <option value="Families">Families</option>
          <option value="Young Professionals">Young Professionals</option>
          <option value="Retirees">Retirees</option>
        </select>
      </div> -->
    </div>
    
    <!-- <div class="form-group">
      <label for="custom-prompt">Custom Prompt (Optional)</label>
      <textarea 
        id="custom-prompt"
        :value="formData.custom_prompt"
        @input="updateField('custom_prompt', $event.target.value)"
        placeholder="Enter any specific instructions or requirements..."
      ></textarea>
    </div> -->

    <div class="model-selector">
      <label>Select AI Models to Test:</label>
      <div class="model-cards">
        <ModelCard
          v-for="model in models"
          :key="model.id"
          :model="model"
          :selected="selectedModels.includes(model.id)"
          @toggle="$emit('toggle-model', model.id)"
        />
      </div>
    </div>

    <button 
      class="test-button"
      @click="$emit('run-tests')"
      :disabled="selectedModels.length === 0 || loading"
    >
      {{ loading ? 'Testing Models...' : `Test ${selectedModels.length} Selected Model${selectedModels.length !== 1 ? 's' : ''}` }}
    </button>
  </div>
</template>

<script>
import ModelCard from './ModelCard.vue'

export default {
  name: 'Controls',
  components: {
    ModelCard
  },
  props: {
    formData: {
      type: Object,
      required: true
    },
    models: {
      type: Array,
      required: true
    },
    selectedModels: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update-form', 'toggle-model', 'run-tests'],
  methods: {
    updateField(field, value) {
      this.$emit('update-form', { [field]: value })
    }
  }
}
</script>

<style scoped>
.controls {
  background: white;
  padding: 30px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
  margin: 0 20px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  margin-bottom: 8px;
  font-weight: 600;
  color: #2c3e50;
}

.form-group input, .form-group select, .form-group textarea {
  padding: 12px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
}

.form-group input:focus, .form-group select:focus, .form-group textarea:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-group textarea {
  resize: vertical;
  min-height: 80px;
}

.model-selector {
  margin-bottom: 30px;
}

.model-selector label {
  display: block;
  margin-bottom: 15px;
  font-weight: 600;
  color: #2c3e50;
  font-size: 1.1em;
}

.model-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
}

.test-button {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  border: none;
  padding: 15px 30px;
  border-radius: 8px;
  font-size: 1.1em;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
}

.test-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(40, 167, 69, 0.3);
}

.test-button:disabled {
  background: #6c757d;
  cursor: not-allowed;
  transform: none;
}

@media (max-width: 768px) {
  .controls {
    padding: 20px;
    margin: 0 10px;
  }
  
  .form-grid {
    grid-template-columns: 1fr;
  }
  
  .model-cards {
    grid-template-columns: 1fr;
  }
}
</style>